/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { DocumentOcrPersonalDataViewModel } from "../types/DocumentOcrPersonalDataViewModel.ts";

export const documentOcrPersonalDataViewModelSchema = z.object({
  fullName: z
    .string()
    .describe("Nome completo extraído dos documentos. Opcional.")
    .nullish(),
  cpf: z.string().describe("Número do CPF extraído. Opcional.").nullish(),
  birthDate: z
    .string()
    .describe("Data de nascimento extraída (dd/MM/yyyy). Opcional.")
    .nullish(),
  mothersName: z.string().describe("Nome da mãe extraído. Opcional.").nullish(),
  gender: z
    .string()
    .describe(
      "Gênero por extenso (Masculino/Feminino); inferido pelo nome quando não consta nos documentos. Opcional.",
    )
    .nullish(),
  nationality: z
    .string()
    .describe("Nacionalidade extraída. Opcional.")
    .nullish(),
  birthCountry: z
    .string()
    .describe("País de nascimento extraído. Opcional.")
    .nullish(),
  birthState: z
    .string()
    .describe(
      "Estado de nascimento extraído (nome ou sigla, conforme constar). Opcional.",
    )
    .nullish(),
  birthCity: z
    .string()
    .describe("Cidade de nascimento extraída. Opcional.")
    .nullish(),
  identityDocumentType: z
    .string()
    .describe(
      "Tipo do documento de identidade lido (RG, CNH, Passaporte, RNE, RNM...). Opcional.",
    )
    .nullish(),
  identityDocumentNumber: z
    .string()
    .describe("Número do documento de identidade. Opcional.")
    .nullish(),
  dispatcherOrgan: z
    .string()
    .describe("Órgão expedidor do documento de identidade. Opcional.")
    .nullish(),
  dispatcherOrganState: z
    .string()
    .describe("UF do órgão expedidor (2 letras). Opcional.")
    .nullish(),
  dispatchDate: z
    .string()
    .describe(
      "Data de expedição/emissão do documento de identidade (dd/MM/yyyy). Opcional.",
    )
    .nullish(),
  foreign: z.optional(z.boolean().describe("Indica se o aluno é estrangeiro.")),
  foreignDegree: z.optional(
    z
      .boolean()
      .describe("Indica se o diploma de graduação foi emitido fora do Brasil."),
  ),
}) as unknown as ToZod<DocumentOcrPersonalDataViewModel>;
